import { useEffect } from 'react'

export const useClickOutsideEvent = (
  ref: HTMLElement | null,
  callback: () => void,
  dependencies: unknown[] = [],
) =>
  useEffect(() => {
    const handleClickOutside = ({ target }: MouseEvent) => {
      if (!(target instanceof HTMLElement)) return

      if (target.classList.contains('modal-mask')) {
        callback()
        return
      }

      // We need to check for HTML because otherwise focus traps will not work properly
      if (ref && !ref.contains(target) && target.nodeName !== 'HTML') {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, ...dependencies])
